"use client";

import { LogosCarousel } from "@/components/logos-carousel";
import { useContent } from "@/components/site/ContentProvider";
import styles from "@/components/logos-carousel.module.css";

/** Full wordmark lockups (not favicon/icon-only marks). Intrinsic sizes match assets. */
const CLIENT_MARKS = [
  { name: "MKIT", src: "/images/clients/full/mkit.webp", w: 960, h: 275 },
  { name: "Kenaz Advisors", src: "/images/clients/full/kenaz.webp", w: 960, h: 208 },
  { name: "CareLend", src: "/images/clients/full/carelend.webp", w: 960, h: 232 },
  { name: "Torque Academy", src: "/images/clients/full/torque.webp", w: 960, h: 173 },
  { name: "CL-Bildung", src: "/images/clients/full/cl-bildung.webp", w: 960, h: 244 },
  { name: "SFNDY", src: "/images/clients/full/sfndy.webp", w: 960, h: 219 },
  { name: "Qimmmah", src: "/images/clients/full/qimmmah.webp", w: 960, h: 206 },
] as const;

/** Uniform looping client wordmarks — ncdai LogosCarousel (ADR-014 clients). */
export function ProductTrustedLogos() {
  const site = useContent();
  return (
    <div className="product_team_set f f-c">
      <span className="label small light_60">{site.labels.trustedBy}</span>
      <LogosCarousel
        columnCount={3}
        direction={site.dir === "rtl" ? "rtl" : "ltr"}
        className="product_logos_carousel"
      >
        {CLIENT_MARKS.map((client) => (
          <span className={styles.mark} key={client.name} title={client.name}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              className={styles.markImg}
              src={client.src}
              alt={client.name}
              width={client.w}
              height={client.h}
              loading="lazy"
              decoding="async"
            />
          </span>
        ))}
      </LogosCarousel>
    </div>
  );
}
